import { defineMessages } from "react-intl";

const commonMessages = defineMessages({
  defaultError: {
    id: "common.messages.defaultError",
    defaultMessage: "Unknown error",
  },
  recordLocked: {
    id: "common.messages.recordLocked",
    defaultMessage:
      "This action is currently blocked because a merge is in progress.",
  },
  minimumLengthError: {
    id: "common.messages.minimumLengthError",
    defaultMessage: "Must be at least {value} characters",
  },
  maximumLengthError: {
    id: "common.messages.maximumLengthError",
    defaultMessage: "Must be at most {value} characters",
  },
  shortMonday: {
    id: "common.messages.shortMonday",
    defaultMessage: "Mon",
  },
  shortTuesday: {
    id: "common.messages.shortTuesday",
    defaultMessage: "Tue",
  },
  shortWednesday: {
    id: "common.messages.shortWednesday",
    defaultMessage: "Wed",
  },
  shortThursday: {
    id: "common.messages.shortThursday",
    defaultMessage: "Thu",
  },
  shortFriday: {
    id: "common.messages.shortFriday",
    defaultMessage: "Fri",
  },
  shortSaturday: {
    id: "common.messages.shortSaturday",
    defaultMessage: "Sat",
  },
  shortSunday: {
    id: "common.messages.shortSunday",
    defaultMessage: "Sun",
  },
  invalidCoupon: {
    id: "common.messages.invalidCoupon",
    defaultMessage: "This coupon is invalid",
  },
  couponAlreadyApplied: {
    id: "common.messages.couponAlreadyApplied",
    defaultMessage: "A coupon has already been applied to this appointment.",
  },
  addOnNotFound: {
    id: "common.messages.addOnNotFound",
    defaultMessage:
      "The add-on this coupon applies to has not been added to this appointment",
  },
});

export default commonMessages;
